var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"min-height":"100vh","max-width":"100%","padding-top":"0px","padding-bottom":"0px","padding-left":"0px","padding-right":"0px"}},[(_vm.isAdmin)?_c('iframe',{staticStyle:{"border":"none"},attrs:{"src":_vm.iframeUrl,"width":"100%","height":"100%"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }